module.exports = __webpack_public_path__ + "img/externally-products.ddfbc4ff.png";